/* unplugin-vue-components disabled */import { render } from "./deviceCheck.vue?vue&type=template&id=65363a58&scoped=true&ts=true"
import script from "./deviceCheck.vue?vue&type=script&lang=ts"
export * from "./deviceCheck.vue?vue&type=script&lang=ts"

import "./deviceCheck.vue?vue&type=style&index=0&id=65363a58&lang=less&scoped=true"

import exportComponent from "/project/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65363a58"]])